import { useEffect, useMemo, useState } from "react";
import { StyledTableWrapper, TableStyles } from "./ResultsTablesStyles";
import { getHeadersForCategory } from "../../utils/headers";
import stringifyValues from "../../utils/stringifyValues";
import ResultsTableHeader from "./ResultsTableHeader";
import type {
  ResultsTableProps,
  VehicleData,
  VehicleTableData
} from "@dealer-center/ddc-pages-inventory-archiver-interface";
import { Table } from "@dealer-center/core-components";
import type { TypeSafeTableColumns } from "@dealer-center/core-components";
import { useSearchParams } from "react-router-dom";

const ResultsTable = (props: ResultsTableProps) => {
  const data: VehicleData[] = useMemo(
    () => stringifyValues(props.data),
    [props.data]
  );
  const [columns, setColumns] =
    useState<TypeSafeTableColumns<VehicleTableData>>();
  const [filteredData, setFilteredData] = useState(data);
  const [params, setSearchParams] = useSearchParams();
  useEffect(() => {
    const headers: TypeSafeTableColumns<VehicleTableData> =
      props.checkedCategories.flatMap(category =>
        getHeadersForCategory(category).map((key: string) => ({
          className: `column-${key?.toLowerCase()}`,
          dataIndex: key as keyof VehicleTableData,
          title: key,
          key
        }))
      );
    setColumns(headers);
  }, [props.checkedCategories]);

  useEffect(() => {
    const filters = {};

    params.forEach((value, key) => {
      if (key !== "accountId") filters[key.toUpperCase()] = value;
    });

    const filtered = data.filter(item => {
      return Object.keys(filters).every(key => {
        if (key.toUpperCase() in item) {
          return (
            item[key.toUpperCase()].toString() === filters[key.toUpperCase()]
          );
        }
        return true;
      });
    });
    setFilteredData(filtered);
  }, [params, data]);

  return (
    <div>
      <StyledTableWrapper>
        {data.length > 0 && (
          <ResultsTableHeader
            checkedCategories={props.checkedCategories}
            data={filteredData}
            onToggleHeaders={props.onToggleHeaders}
          />
        )}
        <Table.Table
          displayFilter
          sortableColumns
          columns={columns || []}
          currentPageSize={100}
          data={filteredData}
          dataDensity="small"
          displayPageSizeSelector={true}
          emptyText="No data found"
          highlightOnHover={true}
          scrollX={1475}
          scrollY={1000}
          tableLayout="auto"
        />
        <TableStyles />
      </StyledTableWrapper>
    </div>
  );
};

export default ResultsTable;
